import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// Wspólna prezentacja parametrów produktu: ikona + etykieta + wartość, bez obramówek.
// items: [{ icon, label, value }] — wartości puste są pomijane.
const SpecGrid = ({ items, className = 'grid-cols-2 sm:grid-cols-3 lg:grid-cols-4' }) => {
  const visible = (items || []).filter(
    (it) => it.value !== null && it.value !== undefined && String(it.value).trim?.() !== ''
  );
  if (!visible.length) return null;
  return (
    <div className={`grid ${className} gap-x-6 gap-y-4`}>
      {visible.map((it, i) => (
        <div key={i} className="min-w-0">
          <div className="flex items-center gap-1.5 text-gray-400">
            <FontAwesomeIcon icon={it.icon} className="text-blue-500 text-sm" />
            <span className="text-xs uppercase tracking-wide">{it.label}</span>
          </div>
          <div className="mt-1 text-base font-semibold text-gray-800 break-words">{it.value}</div>
        </div>
      ))}
    </div>
  );
};

export default SpecGrid;
